import React, { useState } from "react";
import { toast } from "react-toastify";
import { PrimaryButton } from "../../UI";
import { createProductFeed } from "../../../utils/APIs";
import { Field, TextInput } from "./common";
import { PRODUCT_FEEDS_FUNCTION_ID } from "./constants";
import { errorMessage } from "./helpers";

// Opened from the functions catalogue: creates a feed and its saved task.
// The feed name is the task name.
const NewFeed = ({ auth, content, onCreated }) => {
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [creating, setCreating] = useState(false);

    const create = async () => {
        if (!name.trim()) return;
        try {
            setCreating(true);
            const result = await createProductFeed({ ...auth, data: { function_id: PRODUCT_FEEDS_FUNCTION_ID, name: name.trim(), description } });
            toast.success(result?.message);
            onCreated(result?.data?._id);
        } catch (e) {
            toast.error(errorMessage(e));
        } finally {
            setCreating(false);
        }
    };

    return (
        <>
            <div>
                <h1 className="text-xl font-medium leading-tight tracking-tight text-gray-900 md:text-2xl">{content.title}</h1>
                <p className="!m-0 text-sm text-gray-600">{content.description}</p>
            </div>
            <div className="w-full max-w-xl flex flex-col gap-4">
                <Field label="Name" help="Also the name of its saved task">
                    <TextInput value={name} placeholder="Eshop - all devices" onChange={setName} />
                </Field>
                <Field label="Description" help="Optional">
                    <TextInput value={description} onChange={setDescription} />
                </Field>
                <p className="text-xs text-gray-500">
                    New feeds start with a suggested field model and CSV columns, including a locked entity.value column (the lowest available price by default; the price rule can be changed on the CSV columns tab). You can change everything before publishing. The feed is listed under Saved tasks.
                </p>
                <div>
                    <PrimaryButton size="sm" loading={creating} disable={!name.trim()} handleClick={create}>{content.create_feed}</PrimaryButton>
                </div>
            </div>
        </>
    );
};

export default NewFeed;
